import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class DisplayIcon extends BaseOption {
  static userInterfaceComponent = {
    label: "Display Icon",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          label: "Show",
          value: "show",
        },
        {
          label: "Hide",
          value: "hide",
        },
      ],
    },
  };

  static defaultValue = "show";
}
